import { ThemeProvider } from "styled-components";
import { useState, useEffect } from "react";
import { darkTheme, lightTheme } from './utils/Themes.js'
import Navbar from "./components/Navbar";
import './App.css';
import HeroSection from "./components/HeroSection";
import About from "./components/About";
import Skills from "./components/Skills";
import Projects from "./components/Projects";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Experience from "./components/Experience";
import Education from "./components/Education";
import Courses from "./components/Courses";
import ProjectDetails from "./components/ProjectDetails";
import Blog from "./Pages/Blogs/Components/Blog.jsx";
import styled from "styled-components";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToHashElement from './Others/ScrollToHashElement.jsx'
import Finance_QA from './Pages/Blogs/Finance_Q&A.jsx'
const Body = styled.div`
  background-color: ${({ theme }) => theme.bg};
  width: 100%;
  overflow-x: hidden;
`


const Wrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: visible;   

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    z-index: 0;
    background:
      linear-gradient(38.73deg, rgba(204, 0, 187, 0.15) 0%, rgba(201, 32, 184, 0) 50%),
      linear-gradient(141.27deg, rgba(0, 70, 209, 0) 50%, rgba(0, 70, 209, 0.15) 100%);
    clip-path: polygon(
      0 0,
      100% 0,
      100% 100%,
      30% 98%,
      0 100%
    );
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;


function App() {
  const [darkMode, setDarkMode] = useState(true);
  const [openModal, setOpenModal] = useState({ state: false, project: null });

  return (
    <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
      <Router>
        <Navbar />
        <ScrollToHashElement />
        <Body>
          <Routes>
            <Route path="/" element={
              <>
                <HeroSection />
                <Wrapper>
                  <About />
                  <Skills />
                  <Experience />
                </Wrapper>
                <Projects openModal={openModal} setOpenModal={setOpenModal} />
                <Wrapper>
                  <Education />
                  <Courses />
                  <Contact />
                </Wrapper>
              </>
            } />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/finance_Q&A" element={<Finance_QA />} />
          </Routes>
          <Footer />
          {openModal.state && (
            <ProjectDetails openModal={openModal} setOpenModal={setOpenModal} />
          )}
        </Body>
      </Router>
    </ThemeProvider>
  );
}

export default App;
